import { identifierForContextKey } from 'stimulus/webpack-helpers';

export const getAllControllersFromDirectories = contexts => {
  return contexts.map(definitionForModule);
};

export const importAllWithKeys = r => r.keys().map(k => {
  const splitKey = k.split('/');
  return [r(k), splitKey[splitKey.length - 1]];
});

const definitionForModule = mod => {
  var identifier = identifierForContextKey(mod[1]);
  if (identifier) {
    return definitionForModuleAndIdentifier(mod[0], identifier);
  }
};

const definitionForModuleAndIdentifier = (module, identifier) => {
  var controllerConstructor = module.default;
  if (typeof controllerConstructor == "function") {
    return { identifier: identifier, controllerConstructor: controllerConstructor };
  }
};



// WEBPACK FOOTER //
// ./app/javascript/shared/stimulusHelpers.js